export default function prioritizeStr(
  priority1 = '',
  priority2 = '',
  usePriority2 = false
) {
  return (usePriority2 && priority2) || !priority1 ? priority2 : priority1;
}
